import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function DrillCard({ drill, isAdmin, onDelete }) {
  const navigate = useNavigate();

  const getDifficultyColor = (level) => {
    const colors = {
      1: 'bg-green-100 text-green-800',
      2: 'bg-blue-100 text-blue-800',
      3: 'bg-yellow-100 text-yellow-800',
      4: 'bg-orange-100 text-orange-800',
      5: 'bg-red-100 text-red-800'
    };
    return colors?.[level] || colors?.[3];
  };

  const getDifficultyLabel = (level) => {
    const labels = {
      1: 'Beginner',
      2: 'Intermediate',
      3: 'Advanced',
      4: 'Expert',
      5: 'Master'
    };
    return labels?.[level] || 'Unknown';
  };

  return (
    <div className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow p-6 border border-slate-200">
      {/* Header */}
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-slate-800 mb-1">
            {drill?.title}
          </h3>
          <div className="flex gap-2 flex-wrap">
            <span className="text-xs bg-slate-100 text-slate-700 px-2 py-1 rounded">
              {drill?.industry}
            </span>
            <span className="text-xs bg-slate-100 text-slate-700 px-2 py-1 rounded">
              {drill?.type}
            </span>
          </div>
        </div>
        <span className={`text-xs px-2 py-1 rounded font-medium ${getDifficultyColor(drill?.difficultyLevel)}`}>
          {getDifficultyLabel(drill?.difficultyLevel)}
        </span>
      </div>
      {/* Content */}
      <p className="text-slate-600 text-sm mb-4 line-clamp-3">
        {drill?.promptText}
      </p>
      {/* Tags */}
      {drill?.tags && (
        <div className="flex gap-2 flex-wrap mb-4">
          {drill?.tags?.split(',')?.map((tag, index) => (
            <span
              key={index}
              className="text-xs bg-blue-50 text-blue-600 px-2 py-1 rounded"
            >
              #{tag?.trim()}
            </span>
          ))}
        </div>
      )}
      {/* Actions */}
      <div className="flex gap-2 pt-4 border-t border-slate-100">
        <button
          onClick={() => navigate(`/drills/${drill?.id}`)}
          className="flex-1 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors text-sm"
        >
          Start Practice
        </button>
        {isAdmin && (
          <button
            onClick={() => onDelete(drill?.id)}
            className="bg-red-50 hover:bg-red-100 text-red-600 px-4 py-2 rounded-lg font-medium transition-colors text-sm"
          >
            Delete
          </button>
        )}
      </div>
    </div>
  );
}